import { Box, IconButton, Tooltip } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';
import Block from 'sections/campaigns/ui/Editor/components/Block';
import { useOffsiteCampaignEditorState } from 'sections/offsite-campaigns/offsite-campaign-editor/context/UseOffsiteCampaignEditorContext';
import { useTheme } from 'styled-components';

export interface TestingFilterProps {
  title: string;
  detail: string;
  tooltip: string;
  onRemove(): void;
  icon: string;
  deleteButtonAriaLabel?: string;
  /** @obsolete Target element using aria label is the preferred approach. */
  deleteButtonTestId?: string;
  /** @obsolete Target element using aria label is the preferred approach. */
  testId?: string;
}

export const TestingFilter = ({
  title,
  detail,
  onRemove,
  icon,
  deleteButtonAriaLabel,
  deleteButtonTestId,
  testId,
  tooltip,
  children,
}: PropsWithChildren<TestingFilterProps>) => {
  const theme = useTheme();
  const { campaign } = useOffsiteCampaignEditorState();

  return (
    <Block
      icon={icon}
      iconColor={theme.vars.newColor.blue2}
      title={title}
      value={detail}
      campaignState={campaign.state}
      valid={true}
      form={<></>}
      controls={
        <Box verticalPositioning="center" horizontalPositioning="end">
          <div data-cy={testId}>
            {children}
            <Tooltip title={tooltip} position="top" wrapperStyle={{ display: 'inline-block' }}>
              <IconButton
                ariaLabel={deleteButtonAriaLabel}
                icon="trash"
                onClick={onRemove}
                data-testid={deleteButtonTestId}
              />
            </Tooltip>
          </div>
        </Box>
      }
      disableOpen={true}
    />
  );
};
